angular.module('wbDashboard').controller('PlanningRecommendationControllerAurea',
    ['$scope', '$timeout','$q', '$uibModal', '$transition$', 'actionResolve', 'PlanningService', 'Login', 'CommonConstant', 'Track',
function ($scope, $timeout, $q, $uibModal, $transition$, actionResolve, PlanningService, Login, CommonConstant, Track) {

    $scope.pageData = {
        sending: false
    };
    $scope.forms = {};
    $scope.landing = {};
    $scope.action = actionResolve;
    $scope.actionClicked = false;
    $scope.landing = $scope.action.landing_description;
    $scope.landing.image_token = $scope.action.image_token;

    if ($scope.action.action === "new_milestone") {
        $timeout(function() {
            //The planning service action does a 'location:replace' so depending on timing, this landing page
            //must be in the history state so it's replaced and not the page previous to it.  If this isn't
            //inside a timeout, there's a race condition that determines the state and ends with inconsistencies.
            PlanningService.recommendationAction($scope.action, $scope.$state);
        });
        return;
    }
    if ($scope.action.action === "axos_bank_account") {
        $scope.pageData.sending = true;
        Login.createAxosPropertyBag().then(function(bag) {
            $scope.action.action_type_axos_url = $scope.action.action_type + "?referrer=axos&referrer_token="+bag;
        }).finally(function() {
            $scope.pageData.sending = false;
        });
    }

    $scope.recommendationAction = function(action) {
        $scope.pageData.sending = true;
        $scope.actionClicked = true;

        $q.when().then(function(){
            if (action.action === 'axos_bank_account') {
                var modalInstance = $uibModal.open({
                    templateUrl: "app/themes/aurea/segments/planning/planning.recommendation.axos-bank-account-modal.tpl.html",
                    size: 'md',
                    scope: $scope,
                    windowClass: 'axos-redirect-modal'
                });
                modalInstance.result.catch(angular.noop);

                return modalInstance.result;
            }
        }).catch(function(err) {
            return $q.reject('skip');
        }).then(function() {
            return PlanningService.recommendationAction(action, $scope.$state);
        }).then(function() {
            if (PlanningService.get('backToPlanning')) {
                if ($transition$.from().name === "base.overview") {
                    $scope.$state.go('base.overview', {'#': 'planning-recommendations'}, {location: 'replace'});
                } else {
                    $scope.$state.go('base.planning', {}, {location: 'replace'});
                }
            }
        }).then(function() {
            return PlanningService.retrieveRecommendations(true);
        }).catch(function(err) {
            if (err === 'skip') {
                //modal closed
                return;
            }
            throw err;
        }).finally(function() {
            $scope.pageData.sending = false;
        });
    };

    $scope.colorFromBG = function(hex) {
        if (!hex) return;

        var rgb, luminance, bigint;
        hex = hex.replace("#","");
        bigint = parseInt(hex, 16);
        rgb = [bigint >> 16 & 255, bigint >> 8 & 255, bigint & 255];
        luminance = (0.299*rgb[0] + 0.587*rgb[1] + 0.114*rgb[2])/255;
        if (luminance < 0.6) { //dark colors
            return "#f8f9fb"; //light text
        } else { //light colors
            return "#111"; //dark text
        }
    };

    function trackRecommendation() {
        //only track ones directly from recommendation
        if ($scope.action.recommendation_slug) {
            Track.send("Recommendation Viewed", "planning", {recommendation: $scope.action.recommendation_slug});
        }
    }
    trackRecommendation();

    var transitionDeregisterHook;
    transitionDeregisterHook = $scope.$transitions.onBefore({ to: 'base.planning.survey.question.**' }, function(trans) {
        //prevent forwarding to the questions because they could be skipped since they are in the history, but no longer answered
        if (!$scope.actionClicked) {
            //TODO: fix the stopping the transition and forwarding causing a doubling of the history

            //stop the transition, the simulate the click of recommendation in order to clear out forward history in case
            //user went half way through survey then back to here since all answers are lost when they left the survey
            $timeout(function() {$scope.recommendationAction($scope.action);});
            return false;
        }
    });
    $scope.$on('$destroy', function() {
        transitionDeregisterHook();
    });

}]);
